// import { Component, OnInit } from "@angular/core";
// import { SupportService } from "./support-requests.service";
// import { NgxSpinnerService } from "ngx-spinner";
// import { ToastrService } from "ngx-toastr";
// @Component({
//   selector: "app-support-requests",
//   templateUrl: "./support-requests.component.html",
//   styleUrls: ["./support-requests.component.sass"],
// })
// export class SupportRequestsComponent implements OnInit {
//   constructor(
//     private toastr: ToastrService,
//     private spinner: NgxSpinnerService,
//     private supportService: SupportService
//   ) {}

//   allRequests: any[] = [];
//   itemsPerPage: number = 6;
//   totalItems: number = 0;
//   page: number = 1;
//   activePlanType: number = 1; // 1 = upto 4 ton, 2 = 4+ ton, 3 = topup
//   ngOnInit(): void {
//     this.getDriverReq(1);
//   }

//   getDriverReq(page: number) {
//     this.page = page;
//     let data = {
//       limit: this.itemsPerPage,
//       page: page,
//     };

//     this.supportService.getDriverRequests(data).subscribe((result: any) => {
//       if (result.statusCode == 200) {
//         this.allRequests = result.data;
//         this.spinner.hide();
//         this.totalItems = result.pagination?.total || 0;
//       } else {
//         this.spinner.hide();
//         this.toastr.error(result.message);
//       }
//     });
//   }

//   getUserReq(page: number) {
//     this.page = page;
//     let data = {
//       limit: this.itemsPerPage,
//       page: page,
//     };

//     this.supportService.getUserRequests(data).subscribe((result: any) => {
//       if (result.statusCode == 200) {
//         this.allRequests = result.data;
//         this.spinner.hide();
//         this.totalItems = result.pagination?.total || 0;
//       } else {
//         this.spinner.hide();
//         this.toastr.error(result.message);
//       }
//     });
//   }
// }

import { Component, OnInit } from "@angular/core";
import { SupportService } from "./support-requests.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-support-requests",
  templateUrl: "./support-requests.component.html",
  styleUrls: ["./support-requests.component.sass"],
})
export class SupportRequestsComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private supportService: SupportService
  ) {}

  allRequests: any[] = [];
  itemsPerPage: number = 6;
  totalItems: number = 0;
  page: number = 1;
  activePlanType: number = 1; // 1 = upto 4 ton, 2 = 4+ ton, 3 = topup
  activeTab: "driver" | "user" = "driver";

  selectedImage: string | null = null;

  ngOnInit(): void {
    this.getRequests("driver", 1);
  }

  getRequests(type: "driver" | "user", page: number) {
    this.page = page;
    let data = {
      limit: this.itemsPerPage,
      page: page,
    };

    let request$ =
      type === "driver"
        ? this.supportService.getDriverRequests(data)
        : this.supportService.getUserRequests(data);

    request$.subscribe(
      (result: any) => {
        if (result.statusCode === 200) {
          this.allRequests = result.data;
          this.totalItems = result.pagination?.total || 0;
        } else {
          this.toastr.error(result.message);
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  openImage(img: string) {
    this.selectedImage = img;
  }

  closeImage() {
    this.selectedImage = null;
  }
}
